/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrgData } from './orgData';


export interface IrrReConfigAuthIdentity { 
    vcfOrg?: OrgData;
    vmcOrg?: OrgData;
    tenantOrg?: OrgData;
    supportOrg?: OrgData;
}

